import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import httpClient from "../../utils/httpClient";

interface SKUKeysRequestDetails {
  Action: string;
  ProductId: string | undefined;
}
interface SKUKeysStatusState {
  isLoading: boolean;
  data: {
    Code: number;
    Status: string;
    Message: string;
    Data: {
      skuKeyeExportEnable: boolean;
    } | null;
  } | null;
  error: string | null;
}

const skuKeysStatusInitialState: SKUKeysStatusState = {
  isLoading: true,
  data: null,
  error: null,
};

export const fetchSKUApiKeyStatus = createAsyncThunk<any, SKUKeysRequestDetails>(
  "SKUApiKeyStatusSlice/fetchSKUApiKeyStatus",
  async (skuKeysRequest, thunkApi) => {
    try {
      const response = await httpClient.post("/db/product/sku", skuKeysRequest);

      if (response.status != 200 || response.data.Status !== "success") {
        if (response.data.Status == "error") {
          return thunkApi.rejectWithValue({
            message: response.data.Message,
          });
        } else {
          return thunkApi.rejectWithValue({
            message: "Failed to get sku key status details",
          });
        }
      }
      return response.data;
    } catch (error: any) {
      console.log("🚀 ~ error:", error);
      return thunkApi.rejectWithValue({
        message: "Failed to get sku key status details",
      });
    }
  }
);

export const fetchSKUKeysExportData = createAsyncThunk<any, SKUKeysRequestDetails>(
  "SKUApiKeyStatusSlice/fetchSKUKeysExportData",
  async (skuKeysRequest, thunkApi) => {
    try {
      const response = await httpClient.post("/db/product/sku", skuKeysRequest, {
        responseType: "text",
      });
       if (typeof response.data === "string" && response.status === 200) {
        return response.data;
      }
      return thunkApi.rejectWithValue({
        message: "Failed to get sku key details",
      });
     
    } catch (error: any) {
      console.log("🚀 ~ error:", error);
      return thunkApi.rejectWithValue({
        message: "Failed to get sku key details",
      });
    }
  }
);

const SKUApiKeyStatusSlice = createSlice({
  name: "SKUApiKeyStatusSlice",
  initialState: skuKeysStatusInitialState,
  reducers: {
    resetSKUApiKeyStatusState: (state) => {
      state.isLoading = false;
      state.data = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSKUApiKeyStatus.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        state.data = null;
      })
      .addCase(
        fetchSKUApiKeyStatus.fulfilled,
        (state, action: PayloadAction<any>) => {
          if (action.payload.Status == "success") {
            state.isLoading = false;
            state.data = action.payload;
            state.error = null;
          } else if (action.payload.Status == "error") {
            state.isLoading = false;
            state.data = null;
            state.error = action.payload.message;
          }
        }
      )
      .addCase(
        fetchSKUApiKeyStatus.rejected,
        (state, action: PayloadAction<any>) => {
          state.isLoading = false;
          state.data = null;
          state.error = action.payload.message;
        }
      );
  },
});

export const { resetSKUApiKeyStatusState } = SKUApiKeyStatusSlice.actions;
export default SKUApiKeyStatusSlice.reducer;